import React, {Component} from 'react';
import './ViewSingleCustomerOrder.css';

import {FormattedMessage} from "react-intl";
// import CustomerOrderItemTable from "../CustomerOrderItemTable/CustomerOrderItemTable";
import CustomerOrderItemTable from "../../../Order/SingleOrder/CustomerOrderItemTable/CustomerOrderItemTable";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import {Link} from "react-router-dom";

class ViewSingleCustomerOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            billOrderInfo: [],
            shipOrderInfo: [],
            userData: [],
            createdDate: "",
            orderId: "",
            userId: this.props.userId
        };
    }

    componentDidMount() {
        this.getOrder();
        this.getUser();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            this.getOrder();
            this.getUser();
        }

    }

    getOrder = () => {
        // console.log("userId",this.state.userId);

        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/orders/last')
            .then((res) => {
                this.setState({
                    orderId: res.data.id,
                    orderData: res.data.orderItems,
                    createdDate: res.data.createdOn,
                    billOrderInfo: res.data.orderInfo.billingAddress,
                    shipOrderInfo: res.data.orderInfo.shippingAddress
                });
                // console.log(res.data);
                // console.log("ord", this.state.orderData);

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getUser = () => {
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId)
            .then((res) => {
                this.setState({
                    userData: res.data
                });
                // console.log(res.data);

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    render() {
        let orderTotalFromChargeDetails = 0;
        let orderSubTotal = 0;
        let orderTax = 0;
        let orderDiscount = 0;
        let initDeliveryDate = '';
        // let initDeliveryDate="2019-04-06";
        return (

            <div className="admin-view-single-order-content">
                {this.state.orderId === '' ?
                    <div>
                        <div className="admin-view-single-order-div ">
                            <h4 className="text-align-center">ご注文情報がございません。</h4>
                            <button className="btn btn-md " id="last-order-quote-btn"><Link to='/quotation/pcb'>
                                <text id="last-btn-txt">見積りスタート</text>
                            </Link></button>
                        </div>
                        <div className="spacer"></div>
                        <div className="spacer"></div>
                    </div>
                    :
                    <div>
                        <div className="admin-view-single-order-div">
                            <div className="title-1">
                                <FormattedMessage id="app.admin.order.view.single.title"
                                                  defaultMessage="ORDER "
                                                  description=""/>&nbsp;
                                <span>#{this.state.orderId}</span>
                                <hr className="no-padding"/>
                            </div>

                            <div className="row">
                                <div className="row view-details-header-div">
                                    <div className="col-md-4">
                                        <label className="admin-admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.view.single.customer.info"
                                                              defaultMessage="Customer Information "
                                                              description=""/>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.order.single.billing.address"
                                                              defaultMessage="Billing Address "
                                                              description=""/>
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.order.single.shipping.address"
                                                              defaultMessage="Shipping Address "
                                                              description=""/></label>

                                    </div>
                                </div>
                                <br/>
                                <div className="row view-details-body-div">
                                    <div className="col-md-4">

                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                                  defaultMessage="Name"
                                                                  description=""/>:&nbsp;
                                            </label>{this.state.userData.name}
                                        </div>
                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                                  defaultMessage="Email"
                                                                  description=""/>:&nbsp;
                                            </label>{this.state.userData.email}
                                        </div>
                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                                  defaultMessage="Email"
                                                                  description=""/>:&nbsp;
                                            </label>{this.state.userData.phone}
                                        </div>

                                    </div>
                                    <div className="col-md-4">

                                        <div>{this.state.billOrderInfo.lastName}
                                            &nbsp; {this.state.billOrderInfo.firstName}</div>
                                        <div>{this.state.billOrderInfo.postalCode}</div>
                                        <div>{this.state.billOrderInfo.province}
                                            &nbsp;{this.state.billOrderInfo.city}</div>
                                        <div>{this.state.billOrderInfo.streetAddress}
                                            &nbsp;{this.state.billOrderInfo.addressLine2}</div>
                                        <div>{this.state.billOrderInfo.cellOrMobileNumber}</div>
                                    </div>
                                    <div className="col-md-4">

                                        <div>{this.state.billOrderInfo.lastName}
                                            &nbsp; {this.state.billOrderInfo.firstName}</div>
                                        <div>{this.state.billOrderInfo.postalCode}</div>
                                        <div>{this.state.billOrderInfo.province}
                                            &nbsp;{this.state.billOrderInfo.city}</div>
                                        <div>{this.state.billOrderInfo.streetAddress}
                                            &nbsp;{this.state.billOrderInfo.addressLine2}</div>
                                        <div>{this.state.billOrderInfo.cellOrMobileNumber}</div>
                                    </div>
                                </div>

                            </div>
                            <hr/>

                            <div className="row">
                                <div className="col-md-6 view-details-body-div">
                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.single.order.date"
                                                          defaultMessage="Order Date "
                                                          description=""/>: &nbsp;
                                    </label>
                                    <span> {this.state.createdDate.substring(0, 10)}</span>
                                    <br/>
                                    {this.state.orderData.map(orderItems => {
                                        let orderTotalJson = JSON.parse(orderItems.chargeDetails.priceInfoJson);
                                        let deliveryDate = orderTotalJson.deliveryDate;
                                        if (deliveryDate > initDeliveryDate) {
                                            initDeliveryDate = deliveryDate;
                                        }

                                    })}
                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.single.order.delivery.date"
                                                          defaultMessage="Delivery Date "
                                                          description=""/>: &nbsp;
                                    </label>
                                    <span> {initDeliveryDate}</span>
                                    <br/>
                                </div>
                                {this.state.orderData.map(orderItems => {
                                    let orderTotalJson = JSON.parse(orderItems.chargeDetails.priceInfoJson);
                                    let total = orderTotalJson.total;
                                    let subTotal = orderTotalJson.subTotal;
                                    let taxAmount = orderTotalJson.consumptionTax;
                                    let discount = orderTotalJson.discount;
                                    orderTotalFromChargeDetails = orderTotalFromChargeDetails + total;
                                    orderSubTotal = orderSubTotal + subTotal;
                                    orderTax = orderTax + taxAmount;
                                    orderDiscount = orderDiscount + discount;

                                })}

                                <div className="col-md-2"></div>
                                <div className="col-md-4 pull-right">
                                    <div className="view-single-order-total">

                                        <div>
                                            <div className="col-md-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.sub-total"
                                                                  defaultMessage="Sub Total"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 no-padding">:</div>
                                            <div className="col-md-5 no-padding">
                                        <span className="single-order-money-values">¥ <NumberFormatter
                                            num={orderSubTotal}/></span>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="col-md-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.discount"
                                                                  defaultMessage="Discount"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 no-padding">:</div>
                                            <div className="col-md-5 no-padding">
                                                <span className="single-order-money-values">¥ <NumberFormatter
                                                    num={orderDiscount}/></span>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="col-md-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.tax"
                                                                  defaultMessage="Consumption Tax"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 no-padding">:</div>
                                            <div className="col-md-5 no-padding">
                                                <span className="single-order-money-values">¥ <NumberFormatter
                                                    num={orderTax}/></span></div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr className="quotation-summary-hr"/>
                                            </div>
                                        </div>

                                        <div className="bill-total-font">
                                            <div className="col-md-5 no-padding ">
                                                <FormattedMessage id="app.admin.single.order.bill.total"
                                                                  defaultMessage="Bill Total"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 no-padding">:</div>
                                            <div className="col-md-5 no-padding">
                                                <span className="single-order-money-values">¥ <NumberFormatter
                                                    num={orderTotalFromChargeDetails}/></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 view-details-body-div-single">
                                    <label className="admin-view-single-order-label">
                                        {/* <FormattedMessage id="app.admin.view.single.order.items"
                                                  defaultMessage="Items"
                                                  description=""/>*/}
                                    </label>
                                    <hr/>

                                    <CustomerOrderItemTable orderData={this.state.orderData}/>

                                </div>
                            </div>
                        </div>
                        <div className="spacer"></div>
                        <div className="spacer"></div>
                    </div>
                }
            </div>
        )
    }

}

export default ViewSingleCustomerOrder;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/LastOrderView/ViewSingleCustomerOrder/ViewSingleCustomerOrder.js